import { useState } from 'react';
import dynamic from 'next/dynamic';
import styles from './styles.module.scss';
import BurgerIcon from '@/components/component-library/Icon/types/Burger';

const BurgerMenuSlider = dynamic(import('./BurgerMenuSlider'), { ssr: false });

// Burger navigation menu
const BurgerMenu = () => {
  // Track whether the burger menu is currently open
  const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);

  const handleOpen = () => {
    setBurgerMenuOpen(true);
  };

  const handleClose = () => {
    setBurgerMenuOpen(false);
  };

  return (
    <>
      <div
        className={ styles.burgerIconWrapper }
        onClick={ handleOpen }
      >
        <BurgerIcon />
      </div>
      <BurgerMenuSlider isOpen={ burgerMenuOpen } onClose={ handleClose } />
    </>
  );
};

export default BurgerMenu;